import type { FC } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const CategorySection: FC = () => {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            探索ASMR分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            从助眠放松、耳语陪伴到触发音效，六大分类满足你所有的ASMR需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 md:p-6 rounded-lg bg-background-100 hover:bg-background-200/80 transition-all duration-300 border border-background-200/60 hover:border-primary-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 flex-shrink-0">
                  <i className={`${cat.icon} text-lg md:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors duration-200 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-2">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center text-xs text-foreground-400">
                    <div className="w-4 h-4 flex items-center justify-center mr-1">
                      <i className="ri-file-text-line"></i>
                    </div>
                    {cat.articleCount} 篇内容
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategorySection;